export enum MonetaryInstrumentEnum {
    TransferenceCode = 8
}